import React, { useCallback, useEffect, useMemo } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import classnames from "classnames";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 3,
  },
  dayBox: {
    padding: 8,
    textAlign: "center",
    borderRadius: 8,
    border: "1px solid #ddd",
    width: 97,
  },
  selectedDay: {
    border: "1px solid #0085FF",
  },
  dateText: {
    fontWeight: 600,
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
    gap: 6,
  },
  ampmButton: {
    width: 37,
    height: 26,
    background: "#F0F0F0",
    borderRadius: 3,
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  selectedSlot: {
    backgroundColor: "#17C34733 !important",
    color: "#17C347 !important",
  },
  disabledAmPm: {
    opacity: 0.4,
    pointerEvents: "none",
  },
}));

export default function CalendarPicker({ className, dayBoxClassName, selectedDate, setSelectedDate }) {
  const classes = useStyles();
  const now = moment();

  const startDate = useMemo(() => {
    if (now.hour() >= 19) {
      return moment().add(1, "day");
    }
    return moment();
  }, [now]);

  const days = useMemo(() => Array.from({ length: 14 }, (_, i) => moment(startDate).add(i, "days")), [startDate]);

  const handleSelect = useCallback((date, slot) => {
    setSelectedDate({
      availableAt: date.format("YYYY-MM-DD"),
      timeSlot: slot,
    });
  }, []);

  const isToday = useCallback(date => date.isSame(now, "day"), []);

  const getButtonDisabled = useCallback(
    (date, slot) => {
      if (!isToday(date)) return false;

      if (now.hour() < 12) {
        return false;
      }

      if (now.hour() >= 12 && now.hour() <= 19) {
        return slot === "Morning";
      }

      return now.hour() >= 19;
    },
    [now]
  );

  useEffect(
    () => () => {
      setSelectedDate(null);
    },
    []
  );

  return (
    <div className={classnames(classes.container, className)}>
      {days.map(day => {
        const isSelectedDay = selectedDate && selectedDate.availableAt === day.format("YYYY-MM-DD");

        return (
          <div
            key={day.format("YYYY-MM-DD")}
            className={classnames(classes.dayBox, isSelectedDay && classes.selectedDay, dayBoxClassName)}
          >
            <Typography className={classes.dateText}>
              {day.format("DD")} {day.format("MMM")}
            </Typography>
            <div className={classes.buttons}>
              <div
                className={classnames(
                  classes.ampmButton,
                  isSelectedDay && selectedDate.timeSlot === "Morning" && classes.selectedSlot,
                  getButtonDisabled(day, "Morning") && classes.disabledAmPm
                )}
                onClick={() => handleSelect(day, "Morning")}
              >
                AM
              </div>
              <div
                className={classnames(
                  classes.ampmButton,
                  isSelectedDay && selectedDate.timeSlot === "Afternoon" && classes.selectedSlot,
                  getButtonDisabled(day, "Afternoon") && classes.disabledAmPm
                )}
                onClick={() => handleSelect(day, "Afternoon")}
              >
                PM
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
